import { POPULATE_PROFILE } from "store/types";

export const populateProfile = (profile = {}) => ({
  type: POPULATE_PROFILE,
  payload: profile,
});

/** Nobody is signed in. */
export const signedOut = () => ({ type: POPULATE_PROFILE, payload: false });
